module.exports = "/_next/static/images/b215694a71851ff9a18dc680804dab35-background-xs.png";